import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";

import { BenefitTotal } from "src/app/models/benefit-summary";
import { CancelEnrollmentRequest, CancelEnrollmentRequestItem, CancelEnrollmentRequestPayload } from "src/app/models/enrollment-request-cancel";
import { TableColumn } from "src/app/models/table";
import { FormValidationService } from "src/app/services/form-validation.service";
 

@Component({
    selector: 'mwp-benefit-enrollment-wizard-cancel-request',
    templateUrl: './cancel-request.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CancelBenefitRequestComponent implements OnInit {
    @Input() public cancelBenefit: CancelEnrollmentRequest;
    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();
    
    public showSummary: boolean;
    
    public showSummaryTotal: boolean;
    public benefitTotal = new BenefitTotal();

    public termForm: FormGroup;
    public termFormArrayName: string = 'termFormArrayName';
    public termSelectedCheckboxName: string = 'isSelected';
    public cancelBenefitData = new MatTableDataSource<CancelEnrollmentRequestItem>();
    public cancelBenefitColumns: TableColumn[] = [
        {
            columnName: '',
            propertyId: this.termSelectedCheckboxName,
            columnType: TableColumnType.checkBoxSelectAll,
            width: '8%',
        },
		{
			columnName: 'Benefit',
            propertyId: 'enrollmentName',
            columnType: TableColumnType.label,
		},
	];

    constructor(
        private formBuilder: FormBuilder,
    ){
    }

    ngOnInit(){
        this.cancelBenefitData.data = this.cancelBenefit.items;

        let l_FormArray: FormArray = new FormArray([], FormValidationService.formArrayRequiresCheckboxChecked(this.termSelectedCheckboxName));
        this.cancelBenefitData.data.forEach((item: CancelEnrollmentRequestItem) => {
            l_FormArray.push(
                this.formBuilder.group({
                    requestID: [item.requestID],
                    enrollmentName: [item.enrollmentName],
                    [this.termSelectedCheckboxName]: [item.isSelected, item.isRequired ? Validators.required : null]
                })
            );
        });

        this.termForm = this.formBuilder.group({
            [this.termFormArrayName]: l_FormArray,
        });
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public submitTermComplete() {
        const l_CancelEnrollmentRquest: CancelEnrollmentRequestPayload = new CancelEnrollmentRequestPayload();

        const l_AssignArray = <FormArray>this.termForm.get(this.termFormArrayName) as FormArray;
        l_AssignArray.controls.map((gaa) => {
            if (gaa.get(this.termSelectedCheckboxName).value)
                l_CancelEnrollmentRquest.requestIDs.push(gaa.get('requestID').value);
        });

        this.emitComplete.emit(l_CancelEnrollmentRquest);
    }
}